if (!customElements.get('swe-warranty-badge')) {
  customElements.define('swe-warranty-badge', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button = this.querySelector('button');
      this.tip = this.querySelector('[role="tooltip"]');
      this.pinned = false;
      this.open = false;
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') this.show();
      }, options);
      this.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !this.pinned && !this.contains(document.activeElement)) this.hide();
      }, options);
      this.button.addEventListener('focus', () => this.show(), options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.hide();
      }, options);
      this.button.addEventListener('click', () => {
        if (this.pinned) this.hide();
        else { this.pinned = true; this.show(); }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) this.hide();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.open) this.hide();
      }, options);
    }
    show() {
      this.open = true;
      this.tip.hidden = false;
      this.button.setAttribute('aria-expanded', 'true');
      // Keep reused placements within the viewport, including a wrapped mobile row.
      this.tip.style.transform = '';
      const rect = this.tip.getBoundingClientRect();
      const offset = rect.left < 12 ? 12 - rect.left : Math.min(0, window.innerWidth - 12 - rect.right);
      this.tip.style.transform = `translateX(${offset}px)`;
    }
    hide() {
      this.open = false;
      this.pinned = false;
      this.tip.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
